import { getJson } from './getJson/index.js';
import { postJson } from './postJson/index.js';
import { patchJson } from './patchJson/index.js';
import './chuck/fetchHandler-BhyMZZdW.js';

var ULRequest = {
    getJson: getJson,
    postJson: postJson,
    patchJson: patchJson
};

export { ULRequest };
